import apiService from './ApiService';

class MateriaService {
  async getMaterias(options = {}) {
    const params = new URLSearchParams();
    if (options.idRegional) params.append('idRegional', options.idRegional);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const response = await apiService.get(`/materias${qs ? `?${qs}` : ''}`);
    const materias = response?.materias || response?.Materias || response?.data || response || [];
    const items = Array.isArray(materias) ? materias : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getMateriasActivas(options = {}) {
    const params = new URLSearchParams();
    if (options.idRegional) params.append('idRegional', options.idRegional);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const response = await apiService.get(`/materias/activos${qs ? `?${qs}` : ''}`);
    const materias = response?.materias || response?.Materias || response?.data || response || [];
    const items = Array.isArray(materias) ? materias : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getMisMaterias(options = {}) {
    const params = new URLSearchParams();
    if (options.idRegional) params.append('idRegional', options.idRegional);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const response = await apiService.get(`/materias/mis${qs ? `?${qs}` : ''}`);
    const materias = response?.materias || response?.Materias || response?.data || response || [];
    const items = Array.isArray(materias) ? materias : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getMateriasPublicasPorAnio(regionalId, areaId) {
    if (!regionalId) {
      throw new Error('No se encontró el regional.');
    }
    if (!areaId) {
      throw new Error('No se encontró el área.');
    }
    const response = await apiService.getPublic(`/materias/publicas/por-anio?regionalId=${encodeURIComponent(regionalId)}&areaId=${encodeURIComponent(areaId)}`);
    const anios = response?.anios || response?.Anios || response?.data || response || [];
    return Array.isArray(anios) ? anios : [];
  }

  async getMateriasPublicasPorAnioConAsistentes(regionalId, areaId) {
    if (!regionalId) {
      throw new Error('No se encontró el regional.');
    }
    if (!areaId) {
      throw new Error('No se encontró el área.');
    }
    const response = await apiService.getPublic(`/materias/publicas/por-anio-con-asistentes?regionalId=${encodeURIComponent(regionalId)}&areaId=${encodeURIComponent(areaId)}`);
    const anios = response?.anios || response?.Anios || response?.data || response || [];
    return Array.isArray(anios) ? anios : [];
  }

  async getMateriasPublicasPorAnioConAsistentesGpt(regionalId, areaId) {
    if (!regionalId) {
      throw new Error('No se encontró el regional.');
    }
    if (!areaId) {
      throw new Error('No se encontró el área.');
    }
    const response = await apiService.getPublic(`/materias/publicas/por-anio-con-asistentes-gpt?regionalId=${encodeURIComponent(regionalId)}&areaId=${encodeURIComponent(areaId)}`);
    const anios = response?.anios || response?.Anios || response?.data || response || [];
    return Array.isArray(anios) ? anios : [];
  }

  async getAsistentesPublicosPorMateria(materiaId, regionalId, areaId) {
    if (!materiaId) {
      throw new Error('No se encontró la materia seleccionada.');
    }
    if (!regionalId) {
      throw new Error('No se encontró el regional.');
    }
    if (!areaId) {
      throw new Error('No se encontró el área.');
    }
    const response = await apiService.getPublic(`/materias/publicas/${materiaId}/asistentes?regionalId=${encodeURIComponent(regionalId)}&areaId=${encodeURIComponent(areaId)}`);
    const asistentes = response?.asistentes || response?.Asistentes || response?.data || response || [];
    return Array.isArray(asistentes) ? asistentes : [];
  }

  async getAsistentesPublicosPorMateriaGpt(materiaId, regionalId, areaId) {
    if (!materiaId) {
      throw new Error('No se encontró la materia seleccionada.');
    }
    if (!regionalId) {
      throw new Error('No se encontró el regional.');
    }
    if (!areaId) {
      throw new Error('No se encontró el área.');
    }
    const response = await apiService.getPublic(`/materias/publicas/${materiaId}/asistentes-gpt?regionalId=${encodeURIComponent(regionalId)}&areaId=${encodeURIComponent(areaId)}`);
    const asistentes = response?.asistentes || response?.Asistentes || response?.data || response || [];
    return Array.isArray(asistentes) ? asistentes : [];
  }

  async validateAsistentePassword(idOpenAIAssistant, regionalId, areaId, password) {
    if (!idOpenAIAssistant) {
      throw new Error('No se encontró el asistente.');
    }
    if (!regionalId) {
      throw new Error('No se encontró el regional.');
    }
    if (!areaId) {
      throw new Error('No se encontró el área.');
    }
    const response = await apiService.postPublic('/Asistente/publico/validar-password', {
      idOpenAIAssistant,
      regionalId,
      areaId,
      password
    });
    return response;
  }

  async getMateriaById(id) {
    const response = await apiService.get(`/materias/${id}`);
    const list = response?.materias || response?.Materias || [];
    return Array.isArray(list) && list.length > 0 ? list[0] : response;
  }

  async createMateria(payload) {
    const response = await apiService.post('/materias', payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear la materia.';
      throw new Error(msg);
    }
    return response;
  }

  async updateMateria(id, payload) {
    const response = await apiService.put(`/materias/${id}`, payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar la materia.';
      throw new Error(msg);
    }
    return response;
  }

  async updateMateriaActivo(id, activo) {
    const response = await apiService.put(`/materias/${id}/activo`, { activo });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el estado de la materia.';
      throw new Error(msg);
    }
    return response;
  }

  async deleteMateria(id) {
    return apiService.delete(`/materias/${id}`);
  }

  async getProfesoresPorMateria(materiaId) {
    if (!materiaId) {
      throw new Error('No se encontró la materia seleccionada.');
    }
    const response = await apiService.get(`/materias/${materiaId}/profesores`);
    const profesores = response?.profesores || response?.Profesores || response?.data || response || [];
    return Array.isArray(profesores) ? profesores : [];
  }

  async assignProfesores(materiaId, profesorIds) {
    if (!materiaId) {
      throw new Error('No se encontró la materia seleccionada.');
    }
    const ids = Array.isArray(profesorIds) ? profesorIds : [];
    const response = await apiService.post(`/materias/${materiaId}/profesores/asociar`, {
      profesorIds: ids
    });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos asociar los profesores.';
      throw new Error(msg);
    }
    return response;
  }

  async removeProfesores(materiaId, profesorIds) {
    if (!materiaId) {
      throw new Error('No se encontró la materia seleccionada.');
    }
    const ids = Array.isArray(profesorIds) ? profesorIds : [];
    const response = await apiService.post(`/materias/${materiaId}/profesores/desasociar`, {
      profesorIds: ids
    });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos desasociar los profesores.';
      throw new Error(msg);
    }
    return response;
  }

  async getAnios() {
    const response = await apiService.get('/materias/anios');
    const anios = response?.anios || response?.Anios || response?.data || response || [];
    return Array.isArray(anios) ? anios : [];
  }

  async getAniosActivos() {
    const response = await apiService.get('/materias/anios/activos');
    const anios = response?.anios || response?.Anios || response?.data || response || [];
    return Array.isArray(anios) ? anios : [];
  }

  async getAnioById(id) {
    const response = await apiService.get(`/materias/anios/${id}`);
    const list = response?.anios || response?.Anios || [];
    return Array.isArray(list) && list.length > 0 ? list[0] : response;
  }

  async updateAnio(id, valor) {
    const response = await apiService.put(`/materias/anios/${id}`, { valor });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el año.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAnioActivo(id, activo) {
    const response = await apiService.put(`/materias/anios/${id}/activo`, { activo });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el año.';
      throw new Error(msg);
    }
    return response;
  }
}

const materiaService = new MateriaService();

export default materiaService;
